import React, { useState } from 'react'
import CreateReminder from './CreateReminder';
//import CreateReminder from './CreateReminder'

function CreateEvent({ choiceEvent, setChoiceEvent, setcreateEvent }) {
    //const [choice, setChoice] = useState('event');

    // Function to generate options for select
    const generateOptions = () => {
        const options = [];
        for (let hour = 0; hour < 12; hour++) {
            options.push(
                <option key={hour} value={hour === 0 ? 12 : hour}>
                    {hour === 0 ? 12 : hour} AM
                </option>
            );
        }
        for (let hour = 12; hour < 24; hour++) {
            options.push(
                <option key={hour} value={hour === 12 ? 12 : hour - 12}>
                    {hour === 12 ? 12 : hour - 12} PM
                </option>
            );
        }
        return options;
    };

    return (
        <div className='create-event'>
            <div className='create-event-top'>
                <span>
                    {choiceEvent == "event" && 'Create Event'}
                    {choiceEvent == "reminder" && 'Create Reminder'}
                </span>
                <i className="fa fa-close" onClick={() => setcreateEvent(false)} ></i>
                {/*<FontAwesomeIcon onClick={() => setcreateEvent(false)} style={{ color: "#00000080" }} icon={faClose} />*/}
            </div>
            <div className="calendar-schedule-events" style={{ marginTop: "30px" }}>
                <span className={choiceEvent == "event" ? "active" : ""} onClick={() => setChoiceEvent('event')} >Event</span>
                <span className={choiceEvent == "reminder" ? "active" : ""} onClick={() => setChoiceEvent('reminder')} >Reminder</span>
            </div>
            {
                choiceEvent == "event" && (
                    <div style={{ marginTop: "35px" }}>
                        <div style={{ marginBottom: "17px" }}>
                            <input className='input-eventt' placeholder={"Event Name"} />
                            <input className='input-eventt' placeholder={"Location"} />
                            <input type='date' className='input-eventt' />
                            <div className='two-select'>
                                <select className='one-select-event' >
                                    {generateOptions()}
                                </select>
                                <select className='one-select-event'>
                                    {generateOptions()}
                                </select>
                            </div>
                            <input className='input-eventt' placeholder={"Add Invitees"} />
                            <textarea placeholder='Details about event' className='textarea-event' />
                            <div className='two-select-bottom' >
                                <select>
                                    <option selected >Repeat </option>
                                    <option>None</option>
                                    <option>Every Day</option>
                                    <option>Every Week</option>
                                    <option>Every Month</option>
                                    <option>Every Year</option>
                                </select>
                                <select>
                                    <option selected >Alert </option>
                                    <option>None</option>
                                    <option>At time of event</option>
                                    <option>5 minutes before</option>
                                    <option>10 minutes before</option>
                                    <option>15 minutes before</option>
                                </select>
                            </div>
                            <div className='btn-event'>
                                <button className='cancel' style={{ marginRight: "20px" }} onClick={() => setcreateEvent(false)}  >
                                    Cancel
                                </button>
                                <button className='create' >Create Event</button>
                            </div>
                        </div>
                    </div>
                )
            }
            {
                choiceEvent == "reminder" && (
                    <CreateReminder setcreateEvent={setcreateEvent} />
                )
            }
        </div>
    );
}

export default CreateEvent;